import { IGetOrdemCompraTotalValoresUseCase } from "../../../presentation/useCases/read/get_ordem_compra_total_valores_use_case";
import { OrdemCompraTotalValor } from "../../models/ordem_compra_total_valor";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraTotalValoresUseCase
 */

export class GetOrdemCompraTotalValoresUseCase implements IGetOrdemCompraTotalValoresUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraTotalValores(
    centroCustos: number[] | null,
    titulo: string | null,
    fornecedores: number[] | null,
    dataOrdemCompraDe: Date | null,
    dataOrdemCompraAte: Date | null,
    ordemCompras: number[] | null,
    produtosServicos: number[] | null,
    dataPagoDe: Date | null,
    dataPagoAte: Date | null,
    subcontas: number[] | null,
    statusOC: number[] | null,
  ): Promise<OrdemCompraTotalValor> {
    return await this.repository.getOrdemCompraTotalValores(
      centroCustos,
      titulo,
      fornecedores,
      dataOrdemCompraDe,
      dataOrdemCompraAte,
      ordemCompras,
      produtosServicos,
      dataPagoDe,
      dataPagoAte,
      subcontas,
      statusOC,
    );
  }
}
